import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { QueryOptions } from 'src/libs/react-query';
import { leaderboardKeys } from './leaderboard-keys';
import { UserStats } from './get-current-leaderboard';

export interface Participant {
  rank: number;
  user_id: string;
  wallet_address: string;
  account_equity: number;
  volume: number;
  pnl: number;
  roi: number;
  points: number;
  tier: string;
}

export interface CurrentLeaderboardResponse {
  start_date: string;
  end_date: string;
  participants: Participant[];
  total: number;
  page_size: number;
  page_number: number;
  user?: UserStats
}
export interface GetLeaderboardParams {
  page: number;
  page_size: number;
  sort_by?: string;
  sort_order?: 'desc' | 'asc';
  useraddress?: string;
}
export const getAllTimeLeaderboard = async (params: GetLeaderboardParams) => {
  const response = await apiClient.get<CurrentLeaderboardResponse>(
    '/v1/public/user-leaderboard/all-time',
    {
      params,
    },
  );

  return response.data;
};

export type UseGetAvailableBalanceLPOptions<TData, TError> = QueryOptions<
  CurrentLeaderboardResponse,
  TError,
  CurrentLeaderboardResponse,
  ReturnType<typeof leaderboardKeys.getAllTimeLeaderboard>
>;

export const useGetAllTimeLeaderboard = <TData = CurrentLeaderboardResponse, TError = Error>(
  params: GetLeaderboardParams,
  options?: UseGetAvailableBalanceLPOptions<TData, TError>,
) => {
  return useQuery({
    queryKey: leaderboardKeys.getAllTimeLeaderboard(params),
    queryFn: () => getAllTimeLeaderboard(params),
    enabled: true,
    ...options,
  });
};
